import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { selectIndustriesSlide, setSelectedIndustries, toggleIndustriesSlide } from '../../store/slices/common';
import SlideOver from '../SlideOver';
import { createIndustries, updateIndustries } from '../../store/slices/api/inner/industriesSlice';

const IndustriesForm = ({
    defaultData,
    fetchData,
}) => {    
    const IndustryIsOpen = useSelector(selectIndustriesSlide);
    const dispatch = useDispatch();

    const defaultValues = {
        industryName: defaultData?.industry_name ?? "",
    }

    const afterAPICall = (response) => {
        fetchData()
        dispatch(toggleIndustriesSlide())
        dispatch(setSelectedIndustries(null))
    }

    const beforeAPICall = (data) => {
        return {
            success: true,
            refactoredData: {
                industryId: defaultData?.industry_id ?? "",
                industryName: data.industryName
            }
        }
    }
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateIndustries : createIndustries,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('industryId', defaultData.industry_id ?? "");
            setValue('industryName', defaultData.industry_name ?? "");
        } else {
            setValue('industryId', "");
            setValue('industryName', "");
        }
    }, [defaultData, setValue]);

    return (
        <SlideOver isOpen={IndustryIsOpen}  toggleOpen={toggleIndustriesSlide} panelName={defaultData ?   "Update Industry" : "Add Industry" }>
            <form onSubmit={handleSubmit}>
                <Input
                    control={control}
                    name="industryName"
                    rules={{
                        required: "this field is required"
                    }}
                    label="Name"
                />
            

                <div className="flex justify-end my-6">
                    <Button isLoading={isLoading}>
                        {defaultData ? "Save changes" : "Submit"}
                    </Button>
                </div>
            </form>
        </SlideOver>
    )
}

export default IndustriesForm